export enum StatusResponse {
    BEING_ENTERED = 'sisestamisel',
    IN_PROCEEDING = 'menetlemisel',
    SCANNED = 'skaneerimisel',
    QUALITY_CONTROL = 'kvaliteedi kontrollil',
    READY_FOR_ARCHIVING = 'valmis arhiveerimiseks',
    ARCHIVED = 'arhiveeritud',
    PENDING = 'ootel',
    DECISION_MADE = 'otsustatud',
    CANCELLED = 'makse tühistatud',
    PAYMENT = 'maksmisel',
    IN_PROCESS = 'pooleli'
}
